(() => {
  'use strict';
  const routesNode = document.getElementById('IndiraRoutes');
  if (!routesNode) return;
  const routes = JSON.parse(routesNode.textContent);
  const q = (s, root = document) => root.querySelector(s);
  const qa = (s, root = document) => [...root.querySelectorAll(s)];
  let cartBusy = false, cartDirty = false, lastFocus = null, variantRequest = 0;
  function announce(message) { const el = q('#CartAnnouncer'); if (el) el.textContent = message; }
  function openDialog(dialog, trigger) {
    if (!dialog || dialog.open) return;
    lastFocus = trigger || document.activeElement;
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    if (lastFocus?.isConnected) lastFocus.focus();
  }
  async function getJSON(url, options = {}) {
    const response = await fetch(url, { ...options, credentials: 'same-origin', headers: { Accept: 'application/json', ...options.headers } });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'No pudimos actualizar tu carrito. Inténtalo nuevamente.');
    return data;
  }
  async function refreshCart() {
    const root = new URL(routes.root, window.location.origin);
    root.searchParams.set('section_id', 'cart-drawer');
    root.searchParams.set('_', Date.now().toString());
    const response = await fetch(root, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('No pudimos mostrar el carrito. Puedes revisarlo en la página de carrito.');
    const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
    const next = documentFragment.querySelector('#CartContent'), current = q('#CartContent');
    if (!next || !current) throw new Error('No pudimos mostrar el carrito. Revisa la página de carrito.');
    const active = document.activeElement;
    const focusKey = active?.getAttribute('data-cart-change');
    current.replaceWith(next);
    const count = next.dataset.itemCount || '0';
    qa('[data-cart-count]').forEach(el => { el.textContent = count; });
    if (q('#CartDrawer')?.open) {
      const focusTarget = focusKey ? qa('[data-cart-change]', next).find(el => el.dataset.cartChange === focusKey) : null;
      (focusTarget || q('[data-close]', next))?.focus();
    }
    return next;
  }
  async function openCart(trigger) {
    openDialog(q('#CartDrawer'), trigger);
    try { await refreshCart(); } catch (error) {
      const box = q('#DrawerError'); if (box) box.textContent = error.message;
    }
  }
  async function changeCart(button) {
    if (cartBusy) return;
    const drawer = q('#CartDrawer');
    const focusKey = button.dataset.cartChange;
    const quantity = Number(button.dataset.quantity);
    if (!Number.isInteger(quantity) || quantity < 0) return;
    cartBusy = true; drawer?.setAttribute('aria-busy', 'true');
    qa('[data-cart-change]').forEach(el => { el.disabled = true; });
    try {
      await getJSON(routes.change, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: focusKey, quantity }) });
      cartDirty = true;
      await refreshCart(); announce('Carrito actualizado.');
    } catch (error) {
      // Reconcile actual Shopify state after quantity validation or a render failure.
      try { await refreshCart(); } catch (_) { /* Keep the last visible cart and the recovery link. */ }
      const box = q('#DrawerError'); if (box) box.textContent = error.message;
      announce(error.message);
    } finally {
      cartBusy = false; drawer?.removeAttribute('aria-busy');
      qa('[data-cart-change]').forEach(el => { el.disabled = false; });
    }
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-product-form]')) return;
    const submit = q('[name="add"]', form);
    if (!submit) return;
    event.preventDefault();
    if (submit.disabled || form.getAttribute('aria-busy') === 'true' || cartBusy) return;
    const errorBox = q('[data-product-error]', form);
    if (errorBox) errorBox.textContent = '';
    const body = new FormData(form);
    submit.disabled = true; cartBusy = true; form.setAttribute('aria-busy', 'true');
    let added = false;
    try {
      await getJSON(routes.add, { method: 'POST', body });
      added = true; cartDirty = true;
      await refreshCart();
      announce('Pieza agregada al carrito.'); openDialog(q('#CartDrawer'), submit);
    } catch (error) {
      if (added) {
        // The add succeeded. Never retry a mutation just because rendering failed.
        window.location.assign(routes.cart); return;
      }
      if (errorBox) errorBox.textContent = error.message;
      announce(error.message);
    } finally {
      submit.disabled = false; cartBusy = false; form.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('change', async event => {
    const selector = event.target.closest('[data-option-selector]');
    if (!selector) return;
    const root = selector.closest('[data-product-section]');
    if (!root) return;
    const token = ++variantRequest;
    const focusId = selector.id;
    const optionIDs = qa('[data-option-selector]', root).map(el => el.selectedOptions[0].dataset.optionId);
    if (optionIDs.some(id => !id)) return;
    const url = new URL(root.dataset.productUrl, window.location.origin);
    url.searchParams.set('option_values', optionIDs.join(','));
    url.searchParams.set('section_id', root.dataset.productSection);
    const form = q('[data-product-form]', root);
    form?.setAttribute('aria-busy', 'true');
    const hiddenVariant = q('input[name="id"]', root); if (hiddenVariant) hiddenVariant.disabled = true;
    const submit = q('[name="add"]', root); if (submit) submit.disabled = true;
    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('No pudimos cargar esta combinación. Vuelve a seleccionar tus opciones.');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = parsed.getElementById(root.id);
      if (!next) throw new Error('No pudimos cargar esta combinación. Vuelve a seleccionar tus opciones.');
      if (token !== variantRequest) return;
      root.replaceWith(next);
      url.searchParams.delete('section_id');
      history.replaceState({}, '', url.pathname + url.search);
      document.getElementById(focusId)?.focus();
      announce('Opciones de la pieza actualizadas.'); initMedia(next);
    } catch (error) {
      if (token !== variantRequest) return;
      form?.removeAttribute('aria-busy');
      const box = q('[data-product-error]', root); if (box) box.textContent = error.message;
      // Keep purchase disabled so a stale variant cannot be added.
    }
  });
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const open = target.closest('[data-open]');
    if (open) { event.preventDefault(); openDialog(document.getElementById(open.dataset.open), open); return; }
    const cart = target.closest('[data-open-cart]');
    if (cart) { event.preventDefault(); openCart(cart); return; }
    const close = target.closest('[data-close]');
    if (close) { closeDialog(close.closest('dialog')); return; }
    const change = target.closest('[data-cart-change]');
    if (change) { changeCart(change); return; }
    const step = target.closest('[data-quantity-step]');
    if (step) {
      const input = q('input[type="number"]', step.closest('.quantity'));
      if (input) { if (Number(step.dataset.quantityStep) > 0) input.stepUp(); else input.stepDown(); input.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    const media = target.closest('[data-media-select]');
    if (media) {
      const root = media.closest('[data-product-section]');
      qa('[data-media-id]', root).forEach(el => { el.hidden = el.dataset.mediaId !== media.dataset.mediaSelect; if (el.hidden) qa('video', el).forEach(v => v.pause()); });
      qa('[data-media-select]', root).forEach(el => el.setAttribute('aria-current', String(el === media)));
      return;
    }
    const zoom = target.closest('[data-zoom]');
    if (zoom) { const image = q('#ZoomImage'); image.src = zoom.dataset.zoom; image.alt = q('img', zoom)?.alt || 'Detalle de la pieza'; openDialog(q('#ImageDialog'), zoom); return; }
    const scroll = target.closest('[data-scroll-target]');
    if (scroll) { const el = document.getElementById(scroll.dataset.scrollTarget); el?.scrollBy({ left: Number(scroll.dataset.scrollDirection) * el.clientWidth * .75, behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth' }); return; }
    const toggle = target.closest('[data-video-toggle]');
    if (toggle) {
      const video = q('video', toggle.parentElement);
      if (video) { if (video.paused) { video.dataset.userPaused = ''; video.play().catch(() => {}); } else { video.dataset.userPaused = 'true'; video.pause(); } }
      return;
    }
    if (target.matches('dialog')) {
      const rect = target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(target);
    }
    const anchor = target.closest('a[href]');
    if (anchor?.closest('#MobileMenu')) closeDialog(q('#MobileMenu'));
    if (!target.closest('.nav details')) qa('.nav details[open]').forEach(el => { el.open = false; });
  });
  document.addEventListener('close', event => {
    if (event.target.id === 'CartDrawer' && cartDirty && q('#CartPageForm')) window.location.reload();
  }, true);
  const initialized = new WeakSet();
  const videoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({ target: video, isIntersecting }) => {
      if (isIntersecting && !video.dataset.userPaused && !matchMedia('(prefers-reduced-motion:reduce)').matches) video.play().catch(() => {});
      else video.pause();
    });
  }, { threshold: .15 }) : null;
  function initMedia(root = document) {
    qa('.ambient-video', root).forEach(video => {
      if (initialized.has(video)) return;
      initialized.add(video);
      const button = q('[data-video-toggle]', video.parentElement);
      const sync = () => { if (button) { button.textContent = video.paused ? 'Reproducir' : 'Pausar'; button.setAttribute('aria-label', video.paused ? 'Reproducir video' : 'Pausar video'); } };
      video.addEventListener('play', sync); video.addEventListener('pause', sync);
      if (matchMedia('(prefers-reduced-motion:reduce)').matches) video.pause();
      if (videoObserver) videoObserver.observe(video);
      else if (!matchMedia('(prefers-reduced-motion:reduce)').matches) video.play().catch(() => {});
      sync();
    });
  }
  document.addEventListener('shopify:section:load', event => initMedia(event.target));
  document.addEventListener('shopify:section:unload', event => qa('video', event.target).forEach(v => videoObserver?.unobserve(v)));
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCart().catch(() => {}); });
  initMedia();
})();
